/**
 * CSS selectors for icon elements that should be excluded from accessibility modifications
 */
export const ICON_SELECTOR = [
  'material-icons',       // Google Material Icons
  'fa',                   // Font Awesome (general)
  'fa-solid',             // Font Awesome solid icons
  'fa-regular',           // Font Awesome regular icons
  'fa-brands',            // Font Awesome brand icons
  'glyphicon',            // Bootstrap Glyphicons
  'icon',                 // Common class for older icon sets
  'mdi',                  // Material Design Icons
  'ion',                  // Ionicons
  'svg-icon',             // Custom SVG icons
  'iconfont',             // Icon fonts from other libraries
  'emoji-icon',           // Emoji icon class
  'bi',                   // Bootstrap Icons
  'octicon',              // GitHub Octicons
  'feather',              // Feather Icons
  'heroicon',             // Heroicons
  'bx',                   // Boxicons
  'ri',                   // Remix Icon
] as const;

/**
 * CSS selector to exclude icon elements
 */
export const NOT_ICON_SELECTORS = `*:not(${ICON_SELECTOR.map(s => `.${s}`).join(',')})`;

/**
 * All element selectors including the not-icon selector
 */
export const ALL_ELEMENT_SELECTORS: readonly string[] = ['', NOT_ICON_SELECTORS];

/**
 * CSS selectors for link elements
 */
export const LINKS_SELECTORS: readonly string[] = ["a[href]"];

/**
 * CSS selectors for header elements
 */
export const HEADER_SELECTORS: readonly string[] = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'];

/**
 * CSS selectors for text elements
 */
export const TEXT_SELECTORS: readonly string[] = [
  ...HEADER_SELECTORS,
  'img',
  'p',
  'i',
  'a',
  'button:not(.cya11y-btn)',
  'label',
  'li',
  'ol'
];

/**
 * CSS selectors for elements that should be affected by dark contrast
 */
export const DARK_CONTRAST_SELECTORS: readonly string[] = [
  ...TEXT_SELECTORS,
  'span',
  'nav',
  'p',
  'a',
  'button',
  'input',
  'textarea',
  'select',
  'label',
  'li',
  'ol',
  'img',
  'i',
  'section',
  'figcaption',
  'body',
  'header',
  'footer',
  'table',
  'td',
  'th',
  'tr',
  'tbody',
  'thead',
  'tfoot'
];